// extracted by mini-css-extract-plugin
export default {"modifiedOnSmall":"ModifiedOnOrVersion_modifiedOnSmall__kPlqQ","modifiedOnLarge":"ModifiedOnOrVersion_modifiedOnLarge__PZDt-"};